import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default function ListLeadsAllowed() {
	return useFeatureAvailable(Feature.LEADS);
}
